import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export const getAOCreatorsSelectOptions = () => [
  {
    value: "all-creators",
    label: (
      <IDHFormattedMessage id="ws_all_creators" defaultMessage="All creators" />
    ),
  },
  {
    value: "only-publishers",
    label: (
      <IDHFormattedMessage
        id="ws-only-publishers"
        defaultMessage="Only publishers"
      />
    ),
  },
];
